<template>
  <div class="ref-branch-locator">
    <!-- District Select -->
    <div class="ref-select-pill">
      <i class="fa fa-map-marker select-icon"></i>
      <select @change="districtchanges($event)" name="district" v-model="selectedDistrict" class="ref-select" required>
        <option value="">{{ isBangla ? 'জেলা নির্বাচন করুন' : 'SELECT DISTRICT' }}</option>
        <option 
          v-for="district in districts" 
          :key="district.id" 
          :value="district.id"
        >
          {{district.districtname}}
        </option>
      </select>
      <i class="fa fa-chevron-down arrow-icon"></i>
    </div>

    <!-- Upazila Select -->
    <div class="ref-select-pill">
      <i class="fa fa-map-o select-icon"></i>
      <select @change="upazilachange($event)" v-model="selectedUpazila" class="ref-select">
        <option value="">{{ isBangla ? 'উপজেলা নির্বাচন করুন' : 'SELECT UPAZILA' }}</option>
        <option 
          v-for="upazilalist in upazilalists" 
          :key="upazilalist.upazila.id" 
          :value="upazilalist.upazila.id"
        >
          {{upazilalist.upazila.Upazila}}
        </option>
      </select>
      <i class="fa fa-chevron-down arrow-icon"></i>
    </div>

    <!-- Federation Select -->
    <div class="ref-select-pill">
      <i class="fa fa-users select-icon"></i>
      <select @change="chanagnfederation($event)" v-model="selectedFederation" class="ref-select">
        <option value="">{{ isBangla ? 'ফেডারেশন নির্বাচন করুন' : 'FEDERATION NAME' }}</option>
        <option value="0">RDRS</option>
        <option 
          v-for="federationName in federationNames" 
          :key="federationName.id" 
          :value="federationName.id"
        >
          {{federationName.FederationName}}
        </option>
      </select>
      <i class="fa fa-chevron-down arrow-icon"></i>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      districts: [],
      upazilalists: [],
      federationNames: [],
      federationIds: [],
      selectedDistrict: '',
      selectedUpazila: '',
      selectedFederation: '',
      isBangla: false
    };
  },
  
  computed: {
    storeFederationId() {
      return this.$store.state.federationId;
    },
    storeFederationName() {
      return this.$store.state.federationName;
    },
    url() {
      return this.$store.state.url;
    }
  },

  methods: {
  
    loadSavedSelections() {
      const savedState = localStorage.getItem('locationSelections');
      if (savedState) {
        const parsedState = JSON.parse(savedState);
        this.selectedDistrict = parsedState.district;
       if (this.selectedDistrict) {
          this.loadUpazilasForDistrict(this.selectedDistrict).then(() => {
            this.selectedUpazila = parsedState.upazila;
            if (this.selectedUpazila) {
              this.loadFederationsForUpazila(this.selectedUpazila).then(() => {
                this.selectedFederation = parsedState.federation;
              });
            }
          });
        }
      }
    },
    
    saveSelections() {
      const selections = {
        district: this.selectedDistrict,
        upazila: this.selectedUpazila,
        federation: this.selectedFederation
      };
      localStorage.setItem('locationSelections', JSON.stringify(selections));
    },

    chanagnfederation(event) {
      const value = event.target.value;
      this.selectedFederation = value;
      const text = event.target.options[event.target.selectedIndex].text;
      
      this.$store.dispatch('updateEventValue', { value, text });
      this.saveSelections();
      
      if (value == 0) {
        this.selectedDistrict='';
        this.selectedUpazila='';
        this.selectedFederation='';
        const selections = {
        district: this.selectedDistrict,
        upazila: this.selectedUpazila,
        federation: this.selectedFederation
      };
      localStorage.setItem('locationSelections', JSON.stringify(selections));
      localStorage.clear();

      window.location.replace(this.url);

      } else {

        window.location.replace(this.url + 'federationdetails/' + value);

      }

    },

    districtchanges(event) {
      const districtId = event.target.value;
      this.selectedDistrict = districtId;
      this.selectedUpazila = '';
      this.selectedFederation = '';
      this.saveSelections();
      
      if (districtId) {
        this.loadUpazilasForDistrict(districtId);
      } else {
        this.upazilalists = [];
        this.federationNames = [];
      }
    },
    
    async loadUpazilasForDistrict(districtId) {
      try {
        const response = await axios.get(this.url + 'getupazilalist/' + districtId);
        this.upazilalists = response.data;
        this.$nextTick(() => { this.retriggerTranslation(); });
      } catch (error) {
        console.error("Error fetching upazilas:", error);
        this.upazilalists = [];
      }
    },

    upazilachange(event) {
      const upazilaId = event.target.value;
      this.selectedUpazila = upazilaId;
      this.selectedFederation = '';
      this.saveSelections();
      
      if (upazilaId) {
        this.loadFederationsForUpazila(upazilaId);
      } else {
        this.federationNames = [];
      }
    },
    
    async loadFederationsForUpazila(upazilaId) {
      try {
        const response = await axios.get(this.url + 'getfederationName/' + upazilaId);
        this.federationNames = response.data;
        this.$nextTick(() => { this.retriggerTranslation(); });
      } catch (error) {
        console.error("Error fetching federations:", error);
        this.federationNames = [];
      }
    },

    async fetchDistricts() {
      try {
        const response = await axios.get(this.url + "getalldistrict");
        this.districts = response.data;
        this.$nextTick(() => { this.retriggerTranslation(); });
      } catch (error) {
        console.error("Error fetching districts:", error);
      }
    },

    retriggerTranslation() {
      // Re-trigger Google Translate on dynamic content
      try {
        const combo = document.querySelector('select.goog-te-combo');
        if (combo && combo.value && combo.value !== 'en') {
          const currentVal = combo.value;
          combo.value = currentVal;
          combo.dispatchEvent(new Event('change'));
        }
      } catch(e) {}
    }
  },
  
  async mounted() {
    try {
      // Detect current language from cookie
      const m = document.cookie.match(/(?:^|;)\s*googtrans=([^;]*)/);
      if (m) {
        const v = decodeURIComponent(m[1]);
        this.isBangla = v.indexOf('/bn') !== -1;
      } else {
        this.isBangla = false;
      }

      await this.fetchDistricts();
      this.loadSavedSelections();
    } catch (error) {
      console.error("Error initializing component:", error);
    }
  }
};
</script>

<style scoped>
.ref-branch-locator {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ref-select-pill {
  position: relative;
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 0 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  min-width: 140px;
  max-width: 250px;
}

.ref-select-pill:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
}

.select-icon {
  color: #1a2b4c;
  font-size: 13px;
  margin-right: 6px;
  flex-shrink: 0;
  pointer-events: none;
}

.arrow-icon {
  color: #333333;
  font-size: 11px;
  margin-left: 6px;
  flex-shrink: 0;
  pointer-events: none;
}

.ref-select {
  background: transparent !important;
  border: none !important;
  outline: none !important;
  color: #1a2b4c !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 6px 4px !important;
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ref-select option {
  color: #1a2b4c !important;
  background-color: #ffffff !important;
  font-weight: 500;
  padding: 8px;
}

@media (max-width: 991px) {
  .ref-branch-locator {
    width: 100%;
    justify-content: flex-start;
  }
  .ref-select-pill {
    flex: 1 1 calc(33.333% - 8px);
    min-width: 0;
    padding: 0 8px;
  }
}
</style>

